<div class="d-block pb-1 modal-header">
  <div class="row pe-2 justify-content-between align-items-start">
    <div class="col modal-title" id="modal-title">
      <div class="row g-0 m-0 align-items-center">
        <span class="col-auto m-0 p-0 h4">Reservation</span>
        @if (mode() !== 'create' && item()) {
          <button
            class="col-auto px-1 py-0 m-0 btn fs-4 text-500 font-monospace align-baseline"
            [appCopyToClipboard]="item()!.number"
            title="Copy to clipboard">
            #{{ item()!.number }}
          </button>
          @if (reservationVersion() !== 'latest') {
            <span class="col-auto px-1 py-0 m-0 badge bg-light text-secondary fs-5 fw-normal font-monospace border">
              v{{ reservationVersion() }}
            </span>
          }
        }
      </div>
    </div>
    <div class="col-auto p-0">
      <div class="row m-0 gap-2 align-items-center justify-content-end">
        @if (mode() !== 'create' && item()) {
          <app-reservation-status-badge [status]="item()!.status" class="col p-0" />
        }
        @if (
          (mode() === 'update' || (mode() === 'readonly' && canModify())) && reservationVersion() === 'latest' && item()
        ) {
          <div class="d-none d-md-block col-auto p-0 h-1em w-1em">
            <button
              type="button"
              class="p-0 btn btn-outline-secondary btn-icon h-2em w-2em"
              (click)="menu.toggle($event)">
              @if (mode() === 'readonly') {
                <i class="fa-solid fa-lock fa-fw"></i>
              } @else {
                <i class="fa-solid fa-unlock fa-fw"></i>
              }
            </button>
            <p-menu #menu [model]="lockMenu()" [popup]="true" class="col-auto m-0 p-0" appendTo="body" />
          </div>
        }
        <div class="col-auto p-0">
          <button
            type="button"
            class="col-auto m-0 btn-close bg-secondary"
            aria-label="Close"
            (click)="dismiss()"></button>
        </div>
      </div>
    </div>
  </div>
  <div class="row g-1 align-items-center">
    <div class="col">
      @if (mode() !== 'create' && item()) {
        <div class="col-12 text-secondary super-small" [title]="item()!.reservationCreatedDate | date: 'medium'">
          Created {{ item()!.reservationCreatedDate | dateAgo }} by {{ item()!.createdBy }}
        </div>
        @if (item()!.reservationModifiedDate !== '0001-01-01T00:00:00') {
          <div class="col-12 text-secondary super-small" [title]="item()!.reservationModifiedDate | date: 'medium'">
            Updated {{ item()!.reservationModifiedDate | dateAgo }} by {{ item()!.modifiedBy ?? 'Unknown' }}
          </div>
        }
      } @else if (mode() !== 'create' && !item()) {
        <div class="mt-2">
          <p-skeleton class="mb-2" width="15rem" height="0.75rem" />
        </div>
        <div class="mt-2">
          <p-skeleton class="mb-2" width="18rem" height="0.75rem" />
        </div>
      } @else if (mode() === 'create') {
        <div class="col-12 text-secondary super-small">
          <span class="">New reservation</span>
        </div>
        <div class="col-12 text-secondary super-small">
          <span class="">Data not saved</span>
        </div>
      }
    </div>
  </div>
</div>
@if (vm$ | async; as vm) {
  <div class="d-flex flex-column p-2 modal-body">
    <form
      id="4d4df1fe-4eb0-4f18-a8db-b1c39239b83f"
      class="d-flex flex-fill flex-column"
      [formGroup]="form"
      (ngSubmit)="submit()">
      <nav ngbNav #nav="ngbNav" class="mt-2 nav-tabs" (navChange)="onNavChange($event)">
        <ng-container ngbNavItem>
          <button ngbNavLink class="fs-7">
            General Data
            @if (generalTabInvalid()) {
              <i class="text-danger fa-solid fa-circle-exclamation"></i>
            } @else if (generalTabModified()) {
              *
            }
          </button>
          <ng-template ngbNavContent formGroupName="general">
            <div class="p-2 h-100">
              <div class="h-100">
                <div class="row g-3 align-items-stretch h-100">
                  <div class="col-md-6">
                    <div class="row g-1">
                      <div class="col-12">
                        <div class="fw-semibold small"><span>General</span></div>
                        <div class="row g-1">
                          @if (item()) {
                            <div class="col-sm-12">
                              <div class="input-group">
                                <div class="form-floating">
                                  <input
                                    type="text"
                                    class="form-control validated"
                                    id="reservationNumber"
                                    [value]="item()!.number"
                                    disabled />
                                  <label for="reservationNumber">Reservation Nr.</label>
                                </div>
                                <button
                                  type="button"
                                  class="input-group-text btn btn-icon border-start-0"
                                  title="Copy to clipboard"
                                  [appCopyToClipboard]="item()!.number">
                                  <i class="fa-solid fa-copy"></i>
                                </button>
                              </div>
                            </div>
                            <div class="col-sm-12">
                              <div class="row g-1">
                                <div class="col">
                                  <div class="input-group">
                                    <div class="form-floating">
                                      <input
                                        type="text"
                                        class="form-control validated"
                                        id="rentalAgreementNumber"
                                        [value]="item()!.rentalAgreementNumber"
                                        disabled />
                                      <label for="rentalAgreementNumber">Rental Agreement Nr.</label>
                                    </div>
                                    <button
                                      type="button"
                                      class="input-group-text btn btn-icon border-start-0"
                                      title="Copy to clipboard"
                                      [appCopyToClipboard]="item()!.rentalAgreementNumber">
                                      <i class="fa-solid fa-copy"></i>
                                    </button>
                                  </div>
                                </div>
                                @if (allowToCreateRa) {
                                  <div class="col-auto">
                                    <button type="button" class="btn btn-icon" (click)="openRaCreation()">
                                      <i class="fa-solid fa-add"></i>
                                    </button>
                                  </div>
                                }
                                @if (item()!.rentalAgreementUid) {
                                  <div class="col-auto">
                                    <button
                                      class="btn btn-icon"
                                      type="button"
                                      (click)="navigateToRa(item()!.rentalAgreementUid!)">
                                      <i class="fa fa-up-right-from-square"></i>
                                    </button>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                          <div class="col-12">
                            <p-iftalabel>
                              <p-autocomplete
                                appBrokerAutocomplete
                                formControlName="brokerClientId"
                                optionLabel="selectedLabel"
                                [forceSelection]="true"
                                [showClear]="true"
                                inputId="brokerClientId">
                                <ng-template let-broker pTemplate="item">
                                  <div class="ps-2 fw-normal" [innerHTML]="broker.optionLabel"></div>
                                </ng-template>
                              </p-autocomplete>
                              <label for="brokerClientId">Broker Id</label>
                            </p-iftalabel>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-floating">
                              <input
                                type="text"
                                class="form-control validated"
                                id="reservationType"
                                [value]="getReservationTypeValueName()"
                                disabled />
                              <label for="reservationType">Reservation Type</label>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="input-group">
                              <div class="form-floating">
                                <input
                                  type="text"
                                  class="form-control validated"
                                  id="brokerReference"
                                  formControlName="brokerReference" />
                                <label for="brokerReference">Broker Reference</label>
                              </div>
                              <button
                                type="button"
                                class="input-group-text btn btn-icon border-start-0"
                                title="Copy to clipboard"
                                [appCopyToClipboard]="form.controls.general.controls.brokerReference.value">
                                <i class="fa-solid fa-copy"></i>
                              </button>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="form-floating">
                              <input
                                type="text"
                                class="form-control validated"
                                id="brokerOrigin"
                                [value]="item()?.brokerOrigin"
                                disabled />
                              <label for="brokerOrigin">Type Of Rate and Method of Payment</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="fw-semibold small">
                          <span>Locations</span>
                        </div>
                        <div class="row g-1 mx-0 justify-content-between">
                          <div class="col-12">
                            <div class="row g-1 px-2 pb-2 m-0 bg-light rounded border">
                              <div class="col-12">
                                <div class="text-muted small">
                                  <i class="text-primary fa fa-location-dot fa-fw"></i>Out
                                </div>
                              </div>
                              <div class="col-8">
                                <p-iftalabel>
                                  <p-autocomplete
                                    #pickupLocationUid
                                    appLocationAutocomplete
                                    [group]="true"
                                    formControlName="pickupLocationUid"
                                    optionLabel="selectedLabel"
                                    [forceSelection]="true"
                                    [showClear]="true"
                                    inputId="pickupLocationUid">
                                    <ng-template let-location pTemplate="item">
                                      <div class="ps-2 fw-normal" [innerHTML]="location.optionLabel"></div>
                                    </ng-template>
                                    <ng-template let-group #group>
                                      <div>
                                        <span class="flag-icon" [class]="group.flagIcon"></span>
                                        <span class="ms-2" [innerHTML]="group.countryName"></span>
                                      </div>
                                    </ng-template>
                                  </p-autocomplete>
                                  <label for="pickupLocationUid">Location</label>
                                </p-iftalabel>
                              </div>
                              <div class="col-4">
                                <p-iftalabel>
                                  <p-datepicker
                                    formControlName="dateOut"
                                    inputId="dateOut"
                                    showIcon
                                    [showTime]="true"
                                    [defaultDate]="pickupDefaultDate"
                                    iconDisplay="input" />
                                  <label for="dateOut">Date</label>
                                </p-iftalabel>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="row g-1 px-2 pb-2 m-0 bg-light rounded border">
                              <div class="col-12">
                                <div class="text-muted small">
                                  <i class="text-primary fa fa-location-dot fa-fw"></i>Return
                                </div>
                              </div>
                              <div class="col-8">
                                <p-iftalabel>
                                  <p-autocomplete
                                    appLocationAutocomplete
                                    [group]="true"
                                    formControlName="dropOffLocationUid"
                                    optionLabel="selectedLabel"
                                    [forceSelection]="true"
                                    [showClear]="true"
                                    inputId="dropOffLocationUid">
                                    <ng-template let-location pTemplate="item">
                                      <div class="ps-2 fw-normal" [innerHTML]="location.optionLabel"></div>
                                    </ng-template>
                                    <ng-template let-group #group>
                                      <div>
                                        <span class="flag-icon" [class]="group.flagIcon"></span>
                                        <span class="ms-2" [innerHTML]="group.countryName"></span>
                                      </div>
                                    </ng-template>
                                  </p-autocomplete>
                                  <label for="dropOffLocationUid">Location</label>
                                </p-iftalabel>
                              </div>
                              <div class="col-4">
                                <p-iftalabel>
                                  <p-datepicker
                                    formControlName="dateIn"
                                    inputId="dateIn"
                                    showIcon
                                    [showTime]="true"
                                    [minDate]="returnMinDate()"
                                    [defaultDate]="returnDefaultDate()"
                                    iconDisplay="input" />
                                  <label for="dateIn">Date</label>
                                </p-iftalabel>
                                @if (form.controls.general.controls.dateIn.hasError('dropOffBeforePickup')) {
                                  <div class="mt-1 text-danger fs-7">Drop-off must be after pick-up.</div>
                                }
                                @if (mode() === 'update' && item() && !canEditDropOffDate()) {
                                  <div class="mt-1 text-muted fs-7">Drop-off can only be changed before pick-up.</div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="fw-semibold small"><span>Other</span></div>
                        <div class="row g-1">
                          <div class="col-sm-6">
                            <div class="form-floating">
                              <input
                                type="number"
                                class="form-control validated"
                                id="numberOfDays"
                                [value]="item()?.numberOfDays"
                                disabled />
                              <label for="numberOfDays">Number of Days</label>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-floating">
                              <input
                                type="text"
                                class="form-control validated"
                                id="flightNumber"
                                [value]="mainDriver()?.flightNumber"
                                [disabled]="true" />
                              <label for="flightNumber">Flight</label>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-floating">
                              <input
                                type="text"
                                class="form-control validated"
                                id="rate"
                                [value]="item()?.rate"
                                disabled />
                              <label for="rate">Rate</label>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-floating">
                              <input
                                type="number"
                                class="form-control validated"
                                id="ratePeriodId"
                                [value]="item()?.ratePeriodId"
                                disabled />
                              <label for="ratePeriodId">Rate Period Id</label>
                            </div>
                          </div>
                          <div class="col-12 h-100">
                            <div class="form-floating h-100">
                              <textarea
                                class="form-control validated"
                                style="min-height: 150px"
                                id="observations"
                                formControlName="observations"></textarea>
                              <label for="observations">Information from the Pre-checked in System</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row g-1">
                      <div class="col-12">
                        <div class="fw-semibold small">
                          <span>Driver</span>
                        </div>
                        <app-driver-card
                          [parentMode]="mode()"
                          [driver]="mainDriver()"
                          (editClicked)="openMainDriverDialog()" />
                      </div>
                      <div class="col-12">
                        <div class="fw-semibold small">
                          <span>Car</span>
                        </div>
                        <div class="row g-1 mx-0 align-items-center justify-content-between">
                          @if (mode() !== 'create' || availableVehicleCategories().length) {
                            <div class="col-12">
                              <app-vehicle-category-select
                                [vehicleCategories]="
                                  mode() === 'readonly' ? vm.vehicleCategories : availableVehicleCategories()
                                "
                                formControlName="vehicleCategoryUid"
                                inputId="vehicleCategoryUid"
                                label="Booked Car" />
                            </div>
                            <div class="col-12">
                              <app-vehicle-category-select
                                [vehicleCategories]="
                                  mode() === 'readonly' ? vm.vehicleCategories : availableVehicleCategories()
                                "
                                formControlName="servedVehicleCategoryUid"
                                inputId="servedVehicleCategoryUid"
                                label="Served Car" />
                              @if (mode() === 'update' && hasBeenPickedUp()) {
                                <div class="mt-1 text-muted fs-7">Served car can only be changed before pick-up.</div>
                              }
                            </div>
                          } @else if (loadingValueItems) {
                            <div class="col-12">
                              <div class="d-flex gap-2 p-2 align-items-center text-muted">
                                <span class="spinner-border spinner-border-sm"></span>
                                Loading available car groups…
                              </div>
                            </div>
                          } @else {
                            <div class="col-12">
                              <div class="m-0 py-2 alert alert-warning">
                                {{
                                  canLoadValueItems()
                                    ? 'No car groups are available for the selected dates and locations.'
                                    : 'Fill in the pick-up and drop-off locations and dates and the broker client to load available car groups.'
                                }}
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      @if (mode() === 'create') {
                        <div class="col-12">
                          <div class="fw-semibold small">
                            <span>Additional Extras</span>
                          </div>

                          <div class="row g-1 mx-0 align-items-center justify-content-between">
                            <div class="col-12">
                              @if (mode() !== 'create' || availableValueItems().length) {
                                <p-iftalabel>
                                  <p-autocomplete
                                    inputId="extraItems"
                                    formControlName="extraItems"
                                    [suggestions]="extraSuggestions"
                                    (completeMethod)="filterExtras($event)"
                                    optionLabel="code"
                                    [multiple]="true"
                                    [unique]="false"
                                    [dropdown]="true"
                                    [forceSelection]="true"
                                    showClear="true"
                                    [fluid]="true" />
                                  <label for="extraItems">Extra items</label>
                                </p-iftalabel>
                              } @else if (loadingValueItems) {
                                <div class="col-12">
                                  <div class="d-flex gap-2 p-2 align-items-center text-muted">
                                    <span class="spinner-border spinner-border-sm"></span>
                                    Loading available extras...
                                  </div>
                                </div>
                              } @else {
                                <div class="col-12">
                                  <div class="m-0 py-2 alert alert-warning">
                                    {{
                                      canLoadValueItems()
                                        ? 'No extras are available for the selected dates, locations and car group.'
                                        : 'Fill in the pick-up and drop-off locations, dates, the broker client and car group to load available extras.'
                                    }}
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                      @if (mode() !== 'readonly') {
                        <div class="col-12">
                          <div class="fw-semibold small">
                            <span>Status</span>
                          </div>
                          <div class="row g-1 mx-0 align-items-center justify-content-between">
                            <div class="col-12">
                              <p-iftalabel>
                                <p-select
                                  [options]="getStatusesOptions()"
                                  formControlName="status"
                                  optionLabel="label"
                                  optionValue="value"
                                  placeholder="Select a Status"
                                  [fluid]="true">
                                  <ng-template let-status pTemplate="item">
                                    <div class="gap-2 flex items-center">
                                      <span><i [class]="status.icon" class="fa-fw"></i></span>
                                      <span class="ms-1">{{ status.label }}</span>
                                    </div>
                                  </ng-template>
                                </p-select>
                                <label for="status">Status</label>
                              </p-iftalabel>
                            </div>
                          </div>
                        </div>
                      }
                      @if (mode() !== 'create') {
                        <div class="col-12">
                          <div class="fw-semibold small">
                            <span>Change History</span>
                          </div>
                          <p-accordion #accordion [style]="{ background: 'none' }" [(value)]="historyExpanded">
                            <p-accordion-panel [value]="1" class="border rounded" #historyPanel>
                              <p-accordion-header>
                                <div>
                                  <i class="fa fa-history fa-fw"></i>
                                  Timeline
                                </div>
                                <ng-template #toggleicon let-active="active">
                                  <div class="p-iconwrapper">
                                    @if (active) {
                                      <i class="pi pi-chevron-up"></i>
                                    } @else {
                                      <i class="pi pi-chevron-down"></i>
                                    }
                                  </div>
                                </ng-template>
                              </p-accordion-header>
                              <p-accordion-content>
                                @if (uid()) {
                                  <app-reservation-history
                                    class="m-0"
                                    [isVisible]="historyPanel.active()"
                                    [reservationUid]="uid()!"
                                    [currentVersion]="reservationVersion()" />
                                }
                              </p-accordion-content>
                            </p-accordion-panel>
                          </p-accordion>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
        <ng-container ngbNavItem="drivers" [disabled]="item() === null && mode() !== 'create'">
          <button ngbNavLink class="fs-7">
            Drivers
            @if (driversTabInvalid()) {
              <i class="text-danger fa-solid fa-circle-exclamation"></i>
            } @else if (driversTabModified()) {
              *
            }
          </button>
          <ng-template ngbNavContent>
            <app-reservation-drivers
              [config]="{
                reservationMode: mode(),
                reservationUid: uid(),
                reservationVersion: reservationVersion(),
                drivers: drivers
              }"
              (driversChanged)="onDriversChanged()"
              class="d-flex flex-fill" />
          </ng-template>
        </ng-container>
        <ng-container ngbNavItem="values" [disabled]="mode() === 'create'">
          <button ngbNavLink class="fs-7">
            Values/Payments
            @if (paymentTabInvalid()) {
              <i class="text-danger fa-solid fa-circle-exclamation"></i>
            } @else if (paymentTabModified()) {
              *
            }
          </button>
          <ng-template ngbNavContent formGroupName="payment">
            <div class="d-flex flex-column h-100 w-100">
              <p-splitter
                [panelSizes]="[getValueGridMinHeight(), 100 - getValueGridMinHeight()]"
                class="d-flex flex-column flex-fill h-100 w-100"
                layout="vertical"
                [minSizes]="[getValueGridMinHeight(), 40]"
                [style]="{ height: '100%', border: '0' }">
                <ng-template pTemplate>
                  <app-reservation-values
                    [config]="{
                      acceptEditable: canEditValueItems(),
                      addable: canEditValueItems(),
                      valueItems: valueItems,
                      availableItems: availableValueItems
                    }"
                    (valueAcceptedChanged)="onValueAcceptedChanged()" />
                </ng-template>
                <ng-template pTemplate>
                  <div class="row g-1 m-0 mx-2 w-100 align-items-start align-content-start overflow-auto">
                    <div class="col-12">
                      <div class="fw-semibold small"><span>Excess</span></div>
                      <div class="row g-1 align-items-center">
                        <div class="col-sm-6 col-lg-3 col-xxl-2">
                          <div class="form-floating">
                            <input
                              type="number"
                              class="form-control validated"
                              id="cdwExcess"
                              formControlName="cdwExcess" />
                            <label for="cdwExcess">CDW</label>
                          </div>
                        </div>
                        <div class="col-sm-6 col-lg-3 col-xxl-2">
                          <div class="form-floating">
                            <input
                              type="number"
                              class="form-control validated"
                              id="tpExcess"
                              formControlName="tpExcess" />
                            <label for="tpExcess">TP</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="fw-semibold small"><span>Invoicing Data</span></div>
                      <div class="row g-1 align-items-center">
                        <div class="col-sm-6 col-lg-3 col-xxl-2">
                          <div class="form-floating">
                            <input
                              type="number"
                              class="form-control validated"
                              id="discountAmount"
                              formControlName="discountAmount" />
                            <label for="discountAmount">Discount Amount</label>
                          </div>
                        </div>
                        <div class="col-sm-6 col-lg-3 col-xxl-2">
                          <div class="form-floating">
                            <input
                              type="number"
                              class="form-control validated"
                              id="numberOfDays"
                              [value]="item()?.numberOfDays"
                              disabled />
                            <label for="numberOfDays">Number of Days</label>
                          </div>
                        </div>
                        <div class="col-sm-6 col-lg-3 col-xxl-2">
                          <div class="form-floating">
                            <input
                              type="number"
                              class="form-control validated"
                              id="taxRate"
                              formControlName="taxRate" />
                            <label for="taxRate">Tax Rate</label>
                          </div>
                        </div>
                        <div class="col-sm-6 col-lg-3 col-xxl-2">
                          <div class="form-floating">
                            <input
                              type="number"
                              class="form-control validated"
                              id="totalTaxValue"
                              formControlName="totalTaxValue" />
                            <label for="totalTaxValue">Total Tax Value</label>
                          </div>
                        </div>
                        <div class="col-sm-6 col-lg-3 col-xxl-2">
                          <div class="form-floating">
                            <input
                              type="number"
                              class="form-control validated"
                              id="additionalKmsPrice"
                              formControlName="additionalKmsPrice" />
                            <label for="additionalKmsPrice">Additional Kms Price</label>
                          </div>
                        </div>
                        <div class="col-sm-6 col-lg-3 col-xxl-2">
                          <div class="form-floating">
                            <select class="form-select validated" id="currency" formControlName="currency">
                              @for (currency of vm.currencies; track currency.uid) {
                                <option [value]="currency.code">{{ currency.code }}</option>
                              }
                            </select>
                            <label for="currency">Currency</label>
                          </div>
                        </div>
                        <div class="col-sm-6 col-lg-3 col-xxl-2">
                          <div class="p-2 bg-100 rounded">
                            <div class="form-check form-switch">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="areKmsIncluded"
                                formControlName="areKmsIncluded" />
                              <label class="form-check-label fs-7" for="areKmsIncluded">Kms Included</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6 col-lg-3 col-xxl-2">
                          <div class="p-2 bg-100 rounded">
                            <div class="form-check form-switch">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="areKmsFreePerDay"
                                formControlName="areKmsFreePerDay" />
                              <label class="form-check-label fs-7" for="areKmsFreePerDay">Kms Free Per Day</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 p-2 mt-2 rounded shadow-sm hightlight-green bt">
                      <div class="row g-1">
                        <div class="col-auto">Invoice ({{ item()?.numberOfDaysToInvoice }} Days)</div>
                        <div class="col-auto flex-fill dot-filler"></div>
                        <div class="col-auto">
                          {{ item()?.totalInvoice | currency: item()?.currency }} /
                          {{ item()?.totalInvoiceWithTax | currency: item()?.currency }}
                        </div>
                      </div>
                      <div class="row g-1">
                        <div class="col-auto">Invoice Cashier ({{ item()?.numberOfDaysToInvoiceCashier }} Days)</div>
                        <div class="col-auto flex-fill dot-filler"></div>
                        <div class="col-auto">
                          {{ item()?.totalCashier | currency: item()?.currency }} /
                          {{ item()?.totalCashierWithTax | currency: item()?.currency }}
                        </div>
                      </div>
                      <div class="row g-1 mb-0 font-weight-bold h5">
                        <div class="col-auto">Total ({{ item()?.numberOfDays }} Days)</div>
                        <div class="col-auto flex-fill dot-filler"></div>
                        <div class="col-auto">
                          {{ item()?.totalValue | currency: item()?.currency }} /
                          {{ item()?.totalValueWithTax | currency: item()?.currency }}
                        </div>
                      </div>
                      <div class="m-0 text-muted text-end lh-sm small">value / value with tax</div>
                    </div>
                  </div>
                </ng-template>
              </p-splitter>
            </div>
          </ng-template>
        </ng-container>
      </nav>
      <div [ngbNavOutlet]="nav" class="d-flex flex-fill"></div>
      @if (errors) {
        <div class="row g-1 pt-1 m-1 align-items-center">
          <div class="col-12">
            <div class="m-0 alert alert-danger">
              @for (error of errors; track $index) {
                <div class="text-center">{{ error }}</div>
              }
            </div>
          </div>
        </div>
      }
    </form>
  </div>
  <div class="modal-footer justify-content-between">
    <div class="col-auto">
      <div class="row gap-1 m-0 justify-content-end">
        @if (
          (mode() === 'update' || (mode() === 'readonly' && canModify())) && reservationVersion() === 'latest' && item()
        ) {
          <div class="d-block d-md-none col-auto p-0">
            <button type="button" class="btn btn-outline-secondary" (click)="menu.toggle($event)">
              @if (mode() === 'readonly') {
                <i class="fa-solid fa-lock fa-fw"></i>
              } @else {
                <i class="fa-solid fa-unlock fa-fw"></i>
              }
            </button>
            <p-menu #menu [model]="lockMenu()" [popup]="true" class="col-auto m-0 p-0" appendTo="body" />
          </div>
        }
        @if (allowToCreateClosedRa) {
          <div class="col-auto p-0">
            <button
              type="button"
              class="btn btn-success"
              ngbAutofocus
              [disabled]="loading || !form.disabled"
              (click)="createClosedRa()">
              <div class="d-flex gap-2 justify-content-center align-items-center">
                <div>
                  <i class="fa-solid fa-check"></i>
                </div>
                <div>Close RA Immediately</div>
              </div>
            </button>
          </div>
        }
        @if (allowToCreateRa) {
          <div class="col-auto p-0">
            <button
              type="button"
              class="btn btn-success"
              ngbAutofocus
              [disabled]="loading || !form.disabled"
              (click)="openRaCreation()">
              <div class="d-flex gap-2 justify-content-center align-items-center">
                <div>
                  <i class="fa-solid fa-file-lines"></i>
                </div>
                <div>Create RA</div>
              </div>
            </button>
          </div>
        }
      </div>
    </div>
    <div class="col">
      <div class="row gap-1 m-0 justify-content-end">
        @if (mode() !== 'readonly') {
          <button
            type="submit"
            form="4d4df1fe-4eb0-4f18-a8db-b1c39239b83f"
            class="col-auto btn btn-success"
            [disabled]="loading || !form.dirty || !form.valid">
            <div class="d-flex gap-2 justify-content-center align-items-center">
              @if (loading) {
                <div>
                  <i class="fa-solid fa-circle-notch fa-spin fa-fw"></i>
                </div>
              } @else {
                <div>
                  <i class="fa-solid fa-save fa-fw"></i>
                </div>
              }
              <div>Save</div>
            </div>
          </button>
        }
        <button type="button" class="col-auto btn btn-outline-secondary" (click)="dismiss()">Close</button>
      </div>
    </div>
  </div>
} @else {
  <div class="modal-body">
    <app-loader />
  </div>
}
